import styles from "./search.module.less";
import SearchInput from "../search-input/search-input";
import SearchNumberOfResults from "../search-number-of-results/search-number-of-results";
import SearchResults, { TSearchResult } from "../search-results/search-results";
import { KeyboardEvent, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { TLinkList } from "../../../../types";

export type TSearchProps = {
  isOpen: boolean;
  isLoadingSearchResults: boolean;
  results?: Array<TSearchResult> | null;
  searchTerm?: string;
  currentPageUrl?: string;
  hasError: boolean;
  scrollAllowedRef?: React.MutableRefObject<HTMLDivElement | null>;
  recommendedLinks?: Array<TLinkList>;
  wrapperClassName?: string;
  closeSearchFunc?: () => void;
  onChangeSearchTerm?: (searchTerm: string) => void;
};

export const Search = ({
  isOpen,
  isLoadingSearchResults,
  results,
  searchTerm,
  currentPageUrl,
  hasError,
  scrollAllowedRef,
  recommendedLinks,
  wrapperClassName,
  closeSearchFunc,
  onChangeSearchTerm,
}: TSearchProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (isOpen) {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }
  }, [isOpen, inputRef]);

  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Escape" && typeof closeSearchFunc === "function") {
      closeSearchFunc();
    }
  };

  return (
    <div
      ref={scrollAllowedRef}
      className={[wrapperClassName ? wrapperClassName : styles.wrapper, isOpen ? "open" : ""].join(" ")}
    >
      <div
        onKeyDown={(event) => onKeyDown(event)}
        className={[styles.innerWrapper, "max-width padded-sides"].join(" ")}
      >
        <div className={styles.inputFieldWrapper}>
          <SearchInput
            inputReference={inputRef}
            onChange={onChangeSearchTerm}
            value={searchTerm}
            icon={"ui-icon-search"}
            hasError={hasError}
            placeholder={t("SEARCH_SEARCH_HERE")}
          />
        </div>
        <SearchNumberOfResults hasError={hasError} results={results} isLoading={isLoadingSearchResults} />
        <div className={styles.results}>
          <SearchResults
            isOpen={isOpen}
            results={results}
            isLoading={isLoadingSearchResults}
            recommendedLinks={recommendedLinks}
            currentPageUrl={currentPageUrl ?? ""}
            closeSearchFunc={closeSearchFunc}
          />
        </div>
      </div>
    </div>
  );
};

export default Search;
